import { AutoAwesome, Cake, Close } from '@mui/icons-material';
import { getAbsoluteFileUrl, normalizeFIO } from 'src/app/helpers/utils';
import SimpleDialog from '@fuse/core/SimpleDialog';
import StaffContactDetails from 'app/shared-components/StaffContactDetails';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, IconButton } from '@mui/material';
import useMessage from 'src/app/hooks/useMessage';

const NewsBirthdaysCard = ({ topsBirthdays = [], employeesBirthdays = [], onClose }) => {
  const { t } = useTranslation('translations');
  const [activeEmplId, setActiveEmplId] = useState(null);
  const { showMessage } = useMessage();

  const handleClose = () => {
    localStorage.setItem('isNewsBirthdayVisible', 'false');
    showMessage({
      message: t('BirthdayCardWillBeClosed'),
      autoHideDuration: 5000,
      variant: 'info',
    });
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden relative">
      {/* Кнопка закрытия */}
      <IconButton
        onClick={handleClose}
        className="absolute top-4 right-4 z-20 bg-white/10 hover:bg-white/30 text-white"
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          zIndex: 20,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
          },
        }}
      >
        <Close />
      </IconButton>
      {/* Шапка с поздравлением */}
      <div className="relative bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 px-8 py-16 md:px-16 md:py-20">
        {/* Декоративные элементы */}
        <div
          className="absolute top-4 left-8 animate-bounce"
          style={{ animationDelay: '0s', animationDuration: '2s' }}
        >
          <AutoAwesome className="w-8 h-8 text-yellow-300" />
        </div>

        <div
          className="absolute bottom-8 left-16 animate-bounce"
          style={{ animationDelay: '1s', animationDuration: '2.2s' }}
        >
          <Cake className="w-9 h-9 text-yellow-200" />
        </div>
        <div
          className="absolute bottom-4 right-20 animate-bounce"
          style={{ animationDelay: '0.3s', animationDuration: '2.8s' }}
        >
          <AutoAwesome className="w-7 h-7 text-pink-200" />
        </div>

        {/* Салюты */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className={`absolute rounded-full bg-white/20 animate-pulse ${
                Math.random() * 2 + 2
              }s ease-in-out infinite delay-${Math.random() * i * 1000}`}
              style={{
                width: `${Math.random() * 8 + 4}px`,
                aspectRatio: 1,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
              }}
            />
          ))}
        </div>

        <div className="relative z-10 text-center">
          <div className="flex items-center justify-center gap-4 mb-6">
            <Cake className="w-32 h-32  text-white" />
          </div>

          <h1 className="text-white mb-6">{t('HappyBirthday')}!</h1>

          <p className="text-white max-w-3xl mx-auto text-16">{t('HappyBirthdayText')}</p>
          <div className="px-8">
            <div>
              <div className="flex justify-center flex-wrap gap-20 mb-10">
                {topsBirthdays.map((top) => (
                  <div
                    key={top.id}
                    className="flex flex-col items-center group cursor-pointer min-w-[90px] mt-10"
                    onClick={() => setActiveEmplId(top.id)}
                  >
                    <div className="relative mb-4">
                      <div className="absolute inset-0 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full blur-md opacity-0 group-hover:opacity-75 transition-opacity duration-300"></div>
                      <div>
                        <Avatar
                          src={getAbsoluteFileUrl(top.photo)}
                          variant="rounded"
                          sx={{ width: 72, height: 72 }}
                        />
                      </div>
                    </div>

                    <p className="text-center text-white dark:text-white ">
                      {top.fullName.surname ? normalizeFIO(top.fullName.surname) : ''}
                    </p>
                    <p className="text-center text-white dark:text-white ">
                      {top.fullName.name ? normalizeFIO(top.fullName.name) : ''}
                    </p>
                    <p className="text-center text-white dark:text-white ">
                      {top.fullName.patronymic ? normalizeFIO(top.fullName.patronymic) : ''}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="my-16">
              <hr className="greetings__sharp-white-line max-w-[450px]"></hr>
            </div>
            <div>
              <div className="flex flex-wrap justify-around gap-10">
                {employeesBirthdays.map((person) => (
                  <div
                    key={person.id}
                    className="flex flex-col items-center group cursor-pointer min-w-[90px]"
                    onClick={() => setActiveEmplId(person.id)}
                  >
                    <div className="relative mb-4">
                      <div className="absolute inset-0 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full blur-md opacity-0 group-hover:opacity-75 transition-opacity duration-300"></div>
                      <div>
                        <Avatar
                          src={getAbsoluteFileUrl(person.photo)}
                          variant="rounded"
                          sx={{ width: 64, height: 64 }}
                        />
                      </div>
                    </div>

                    <p className="text-center text-white dark:text-white ">
                      {person.fullName.surname ? normalizeFIO(person.fullName.surname) : ''}
                    </p>
                    <p className="text-center text-white dark:text-white ">
                      {person.fullName.name ? normalizeFIO(person.fullName.name) : ''}
                    </p>
                    <p className="text-center text-white dark:text-white ">
                      {person.fullName.patronymic ? normalizeFIO(person.fullName.patronymic) : ''}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <SimpleDialog open={!!activeEmplId} onClose={() => setActiveEmplId(null)} noPadding>
        <StaffContactDetails id={activeEmplId} />
      </SimpleDialog>
    </div>
  );
};

export default NewsBirthdaysCard;
